export default {
  reset(state) {
    state.loaded = 0
    state.total = 100
    state.text = ''
    state.name = ''
    state.desciption = ''
  },
  updateLoaded(state, loaded) {
    state.loaded = loaded
  },
  updateText(state, text) {
    state.text = text
  },
  updateName(state, name) {
    state.name = name
  },
  updateDescription(state, name) {
    state.description = name
  },
}
